import React, { useState } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import theme from '../../constants/theme.style.js';
import CustomText from '../customText/CustomText';

const styles = StyleSheet.create({
  container: {
    marginLeft: theme.CONTAINER_MARGIN,
    marginRight: theme.CONTAINER_MARGIN,
    borderBottomColor: theme.GREY_LIGHTER_COLOR,
    borderBottomWidth: 1,
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 20,
  },
  leftContainer: {
    width: '50%',
    paddingTop: theme.CONTAINER_MARGIN,
    paddingBottom: theme.CONTAINER_MARGIN,
    borderRightColor: theme.GREY_LIGHTER_COLOR,
    borderRightWidth: 1,
  },
  rightContainer: {
    width: '50%',
    paddingTop: theme.CONTAINER_MARGIN,
    paddingBottom: theme.CONTAINER_MARGIN,
  },
  text: {
    color: theme.GREY_DARKER_COLOR,
    fontWeight: theme.FONT_WEIGHT_BOLD,
    fontSize: theme.FONT_SIZE_HEADLINE,
    textAlign: 'center',
    fontFamily: 'Nunito_Bold',
  },
  textActive: {
    color: theme.GREEN_DARKER_COLOR,
    fontWeight: theme.FONT_WEIGHT_BOLD,
    fontSize: theme.FONT_SIZE_HEADLINE,
    textAlign: 'center',
    fontFamily: 'Nunito_Bold',
  },
});
const ToggleButton = ({ textLeft, textRight, callback }) => {
  const [leftActive, setleftActive] = useState(true);

  return (
    <View style={styles.container}>
      <TouchableOpacity
        style={styles.leftContainer}
        onPress={() => {
          callback('Inbox');
          setleftActive(true);
        }}
      >
        <CustomText
          style={leftActive ? styles.textActive : styles.text}
          testID="togglebutton__left__text"
        >
          {textLeft}
        </CustomText>
      </TouchableOpacity>
      <TouchableOpacity
        style={styles.rightContainer}
        onPress={() => {
          callback('Outbox');
          setleftActive(false);
        }}
      >
        <CustomText
          style={!leftActive ? styles.textActive : styles.text}
          testID="togglebutton__right__text"
        >
          {textRight}
        </CustomText>
      </TouchableOpacity>
    </View>
  );
};

export default ToggleButton;
